import { render } from "./BrowserNoSupportMessage.vue?vue&type=template&id=99331a82&scoped=true"
import script from "./BrowserNoSupportMessage.vue?vue&type=script&lang=js"
export * from "./BrowserNoSupportMessage.vue?vue&type=script&lang=js"

import "./BrowserNoSupportMessage.vue?vue&type=style&index=0&id=99331a82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99331a82"]])

export default __exports__